import Header from "components/common/Header";
import SideMenu from "components/common/SideMenu";
import Spinner from "components/common/Spinner";
import MessageDialog from "components/dialog/MessageDialog";
import { useAuthInfo } from "hooks/useAuthInfo";
import { useLimitPrice } from "hooks/useLimitPrice";
import { ContextModel } from "models";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

const Mypage2CLayout: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [msgDialog, setMsgDialog] = React.useState<
    { title?: string; message?: string; callback?: () => void } | undefined
  >();

  const auth = useAuthInfo();
  const limitPrice = useLimitPrice();
  const navigate = useNavigate();

  const context: ContextModel = {
    loading: { flg: loading, setState: setLoading },
    msgDialog: { flg: msgDialog, setState: setMsgDialog },
    auth,
    limitPrice,
    navigate,
  };

  return (
    <div className="h-full">
      <div className="h-full flex flex-col">
        <Header ctx={context} />
        <div
          className="flex-1 w-full flex mx-auto"
          style={{ maxWidth: "1920px" }}
        >
          <SideMenu ctx={context} data={auth.data} />
          <div className="flex-1">
            <Outlet context={context} />
          </div>
        </div>
      </div>
      {loading && (
        <div className="bg-black bg-opacity-60 fixed w-screen h-screen top-0 z-[101]">
          <div className="h-full flex justify-center items-center">
            <Spinner />
          </div>
        </div>
      )}
      {msgDialog && (
        <MessageDialog
          title={msgDialog?.title ?? ""}
          message={msgDialog?.message}
          close={() => {
            setMsgDialog(undefined);
            if (msgDialog?.callback) {
              msgDialog.callback();
            }
          }}
        />
      )}
    </div>
  );
};

export default Mypage2CLayout;
